// At the moment we are investing the setting for our CSP on the
// authentication pages (/signin and /register), which needs us to set
// a specific header on them. This utility forces the pages to always
// reload from the server
export const handleAuthPagesRouting = (url: string) => {
    const splitUrl = url.split('?');
    const [mainUrl] = splitUrl;

    const isAuthRoute =
        mainUrl.includes('/signin') || mainUrl.includes('/register');

    if (isAuthRoute) {
        window.location.href = url;
    }
};
